import TermsAndConditionsLink from "./TermsAndConditionsLink";

export default TermsAndConditionsLink